import React from "react";
import * as Icon from "../icons";
import {useTranslation} from "react-i18next";

// TODO: This should probably read from Testimonial metaobjects
const Testimonial = ({testimonialPortraitUrl}: {testimonialPortraitUrl: string}): React.ReactElement => {
  const {t} = useTranslation();

  return <div className="max-md:hidden bg-white p-6 w-full rounded-3xl">
    <div className="flex items-start gap-6">
      <img
        className="w-14 rounded-full"
        src={testimonialPortraitUrl}
        alt="Portrait of a person"
        width="56"
        height="56"
        loading="lazy"
      />
      <div className="w-full flex flex-col gap-4">
        <q className="font-display text-lg tracking-wide first-letter:-ml-2">
          {t("recipe_details.testimonial_to_be_removed")}
        </q>
        <div className="flex gap-4 justify-between items-center">
          <div className="flex gap-1 text-green-900">
            {Array.from({length: 5}).map((_, i) => <Icon.Star key={i} />)}
          </div>
          <div className="text-green-900 font-display text-lg font-semibold tracking-wide mr-2">
            – Jaanika
          </div>
        </div>
      </div>
    </div>
  </div>;
};

export {Testimonial};
